export default __webpack_public_path__ + "static/john-220d31ab5617ae7f2e4f6ab0185d3bab.png";